module.exports = __webpack_public_path__ + "static/media/1C.9898b571.png";